import * as utils from "src/store/utils";
import { setImgStyle, parseImgUrlToken } from "src/filter/modules/img";
const { setPrintArrayContent } = utils;
export const m60SizeMap = {
	// 'F 均码': "欧洲XXXL",
	// 'L/11': "欧洲M",
	// 'M/9': "欧洲S",
	// 'S/7': "欧洲XS",
	// 'XL/13': "欧洲L",
	// 'XS/5': "欧洲",
	// 'XXL/15': "欧洲XL",
	// 'XXXL': "XXL",
	// '确认尺寸F 均码': "欧洲XXXL",
	// '确认尺寸L/11': "欧洲M",
	// '确认尺寸M/9': "欧洲S",
	// '确认尺寸S/7': "欧洲XS",
	// '确认尺寸XL/13': "欧洲L",
	// '确认尺寸XS/5': "欧洲",
	// '确认尺寸XXL/15': "欧洲XL",
	// '确认尺寸XXXL': "XXL"
}
export function setInfo1(info, table1Size) {
	console.log(info, table1Size)
	if (!info || JSON.stringify(info) === JSON.stringify({})) return [];
	return {
		style: {
			fontSize: '3mm',
			flexDirection: "column",
			padding:'0 5mm'
		},
		children: [
			{
				children: [
					{
						style: {
							flexDirection: "column"
						},
						children: [
							{
								text: '款式图:',
								textStyle: this.zoomStyle,
								style: {
									flex: 'none',
									height: '5mm',
									width: '100%'
								}
							},
							{
								render(h) {
									const imgInfo = setImgStyle(info.frontBackImg, true)
									return <div style="width: 60mm;height:60mm;margin: 0 auto;line-height: 60mm;">
										<img src={parseImgUrlToken(imgInfo.url)} class={imgInfo.class} />
									</div>
								}
							}
						]
					},
					{
						style: {
							flexDirection: "column"
						},
						children: [
							{
								style: {
									textAlign: 'center',
									flex: 'none',
									height: '5mm',
									width: '100%'
								},
								textStyle: this.zoomStyle,
								text: `版型及缝制修改要求`

							},
							{
								text: `确认样衣版型及工艺修改:${info.confirmSamplePattern}`,
								textStyle: this.zoomStyle,
								style: {
									flex: 'none',
									height: '20mm',
									width: '100%'
								}
							},
							{
								style: {
									flex: 'none',
									height: '10mm',
									width: '100%'
								},
								textStyle: this.zoomStyle,
								text: `样衣洗水效果:${info.sampleWashEffect}`

							},
							{
								text: `朴条&水晶条位置:${info.stripCrystalLocation}`,
								textStyle: this.zoomStyle,
								style: {
									flex: 'none',
									height: '10mm',
									width: '100%'
								}
							},

							{
								text: `样衣面辅料及整体搭配效果确认:${info.suggestion}`,
								textStyle: this.zoomStyle,
								style: {
									flex: 'none',
									height: '15mm',
									width: '100%'
								}
							},
							{
								text: `花稿位置:${info.draftPosition}`,
								textStyle: this.zoomStyle,
								style: {
									flex: 'none',
									height: '5mm',
									width: '100%'
								}
							},
							{
								text: `确认板颜色:${info.boardColor}`,
								textStyle: this.zoomStyle,
								style: {
									flex: 'none',
									height: '5mm',
									width: '100%'
								}
							},
						]
					}
				]
			},
			{
				style: {
					flexDirection: "column",
					fontSize: '3mm'
				},
				children: setPage1Table(info, table1Size)
				// children: [

				// ]
			}
		]
	}
}

function setPage1Table(info, table1Size) {
	const isBrandCodeSix  = info.brandCode == '6'
	let itemStyleHeight;
	if (table1Size === 25) {
		itemStyleHeight = '7mm'
	}
	else if (table1Size === 35) {
		itemStyleHeight = '5mm'
	}

	return setPrintArrayContent([
		{
			text: '部位',
			propsName: 'usedPosition',
			style: {
				height: '10mm',
				width: info.isWoollen === '15' && '14mm',
				flex: info.isWoollen === '15' && 'none'
			},
			itemStyle: {
				minHeight: itemStyleHeight,
				height: 'auto',
				width: info.isWoollen === '15' && '14mm',
				flex: info.isWoollen === '15' && 'none'
			}
		},
		{
			text: '度量方法(单位:CM)',
			propsName: 'degreeMethod',
			style: {
				height: '10mm',
				width: '65mm',
				flex: 'none'
			},
			itemStyle: {
				minHeight: itemStyleHeight,
				height: 'auto',
				width: '65mm',
				flex: 'none'
			}
		},
		...info.sizeCodeList.map(item => {
			return {
				render(h) {
					const has = m60SizeMap[item.sizeName];
					const isBrandSIXSizeCodeMap = {
						"XS": '欧洲XXS',
						"S": "欧洲XS",
						"M":"欧洲S",
						"L":"欧洲M",
						"XL":"欧洲L",
						"XXL":"欧洲XL",
						"XXXL":"欧洲XXL",
					}
					let  brandSixSizeName
					if(item.sizeName.indexOf('纸样尺寸') >-1 || item.sizeName.indexOf('样衣尺寸') >-1){
						brandSixSizeName = ''
					}else{
						brandSixSizeName = isBrandSIXSizeCodeMap[item.sizeName.replace(/[\u4e00-\u9fa5]/gm, '')]
					}
					return (!isBrandCodeSix ?<div>
						<p>{item.sizeName}</p>
						{has && <p>{has}</p>}
					</div>:<div style={{'line-height': '12px','text-align': 'center'}}>
						<p>{item.sizeName.replace(/[\u4e00-\u9fa5]/gm, '')}</p>
						<p>{item.sizeName.replace(/[^\u4e00-\u9fa5]/gm, '')}</p>
						{brandSixSizeName && <p>{brandSixSizeName}</p>}
					</div>)
				},
				// text: `item.sizeName`,
				propsName: item.sizeName,
				style: {
					height: '10mm'
				},
				itemStyle: {
					minHeight: itemStyleHeight,
					height: 'auto',
				}
			}
		}),
		{
			text: info.isWoollen === '15' ? '公差 +/-' : '公差',
			propsName: 'increaseOrDecrease',
			style: {
				height: '10mm'
			},
			itemStyle: {
				minHeight: itemStyleHeight,
				height: 'auto',
			}
		}
	], info.sizeItemList.map(item => {
		return {
			...item,
			...item.sizeMap
		}
	}), table1Size)
}

export function setInfo2(info, enumList) {
	// const enumListShow = enumToFilter(enumList)
	return {
		style: {
			fontSize: '3mm',
			flexDirection: "column",
			padding:'0 5mm'
		},
		children: [
			{
				children: [
					{
						style: {
							flexDirection: "column",
						},
						children:
							[
								{
									style: {
										flexDirection: "column",
									},
									children: [
										{
											text: '前幅图样',
											textStyle: this.zoomStyle,
											style: {
												borderBottom: 'none',
												height: '8mm',
												flex: 'none',
												width: '100%'
											}
										},
										{
											render(h, inner) {
												const selectItem = info.detailItemList.find(item => Number(item.usedPosition) === 1);
												if(selectItem) {
													return <img style='height: 100%;' src={parseImgUrlToken(selectItem.imgUrl)}></img>;
												} else {
													return <div></div>
												}
											},
											style: {
												borderBottom: 'none',
												borderTop: 'none',
												height: '90mm',
												flex: 'none',
												width: '100%',
												textAlign: 'center',
												paddingBottom:'5px'
											}
										},
									]
								}
							]
					},
					{
						style: {
							flexDirection: "column",
						},
						children: [
							{
								style: {
									flexDirection: "column",
								},
								children: [
									{
										text: '样衣下单数量：',
										textStyle: this.zoomStyle,
										style: {
											borderBottom: 'none',
											height: '5mm',
											flex: 'none',
											width: '100%'
										}
									},
									{
										text: info.sampleQuantityDescription,
										textStyle: this.zoomStyle,
										style: {
											borderTop: 'none',
											height: '10mm',
											color: '#000'
										}
									}
								]
							},
							{
								style: {
									flexDirection: "column",
									flex: 'none',
									width: '100%'
								},
								children: [
									{
										text: '裁剪说明：',
										textStyle: this.zoomStyle,
										style: {
											borderBottom: 'none',
											height: '5mm',
											flex: 'none',
											width: '100%'
										}
									},
									{
										text: info.cuttingDescription,
										textStyle: this.zoomStyle,
										style: {
											borderTop: 'none',
											height: ['15', '16'].includes(info?.isWoollen) ? '42mm' : '48mm',
											color: '#000'
										}
									}
								]
							},
							{
								style: {
									flexDirection: "column",
									flex: 'none',
									width: '100%'
								},
								children: [
									{
										text: '风险评估：',
										textStyle: this.zoomStyle,
										style: {
											borderBottom: 'none',
											height: '5mm',
											flex: 'none',
											width: '100%'
										}
									},
									{
										text: info.riskAssessment,
										textStyle: this.zoomStyle,
										style: {
											borderTop: 'none',
											height: ['15', '16'].includes(info?.isWoollen) ? '16mm' : '10mm',
											color: '#000'
										}
									}
								]
							},
							{
								style: {
									flexDirection: "column",
									flex: 'none',
									width: '100%'
								},
								children: [
									{
										text: '特殊工艺说明：',
										textStyle: this.zoomStyle,
										style: {
											borderBottom: 'none',
											height: '5mm',
											flex: 'none',
											width: '100%'
										}
									},
									{
										text: info.specialProcessDescription,
										textStyle: this.zoomStyle,
										style: {
											borderTop: 'none',
											height: '10mm',
											color: '#000'
										}
									}
								]
							},
						]
					}
				]
			},
			{
				children: [
					{
						style: {
							flexDirection: "column",
						},
						children: [
							{
								style: {
									flexDirection: "column",
								},
								children: [
									{
										text: '后幅图样',
										textStyle: this.zoomStyle,
										style: {
											borderBottom: 'none',
											height: '8mm',
											flex: 'none',
											width: '100%'
										}
									},
									{
										render(h, inner) {
											const selectItem = info.detailItemList.find(item => Number(item.usedPosition) === 2);
											if(selectItem) {
												return <img style='height: 100%;' src={parseImgUrlToken(selectItem.imgUrl)}></img>;
											} else {
												return <div></div>
											}
										},
										style: {
											borderBottom: 'none',
											borderTop: 'none',
											height: '90mm',
											flex: 'none',
											width: '100%',
											textAlign: 'center',
											paddingBottom:'5px'
										}
									},
								]
							}
						]
					},
					{
						style: {
							flexDirection: "column",
						},
						children: [
							{
								style: {
									flexDirection: "column",
									flex: 'none',
									width: '100%'
								},
								children: [
									{
										text: '大货缝制重点及收货标准：',
										textStyle: this.zoomStyle,
										style: {
											borderBottom: 'none',
											height: '5mm',
											flex: 'none',
											width: '100%'
										}
									},
									{
										text: info.qualityRequirementsDescription,
										textStyle: this.zoomStyle,
										style: {
											borderTop: 'none',
											height: ['15', '16'].includes(info?.isWoollen) ? '68mm' : '63mm',
											color: '#000'
										}
									}
								]
							},
							{
								style: {
									flexDirection: "column",
									flex: 'none',
									width: '100%'
								},
								children: [
									{
										text: '后整要求：',
										textStyle: this.zoomStyle,
										style: {
											borderBottom: 'none',
											height: '5mm',
											flex: 'none',
											width: '100%'
										}
									},
									{
										text: info.packageDescription,
										textStyle: this.zoomStyle,
										style: {
											borderTop: 'none',
											height: ['15', '16'].includes(info?.isWoollen) ? '20mm' : '25mm',
											color: '#000'
										}
									}
								]
							},
						]
					}
				]
			},
			{
				children: [
					{
						style: {
							flexDirection: "column",
						},
						children: [
							{
								style: {
									flexDirection: "column",
								},
								children: [
									{
										text: '唛头位置',
										textStyle: this.zoomStyle,
										style: {
											borderBottom: 'none',
											height: '8mm',
											flex: 'none',
											width: '100%'
										}
									},
									{
										render(h, inner) {
											const selectItem = info.detailItemList.find(item => Number(item.usedPosition) === 3);
											if(selectItem) {
												return <img style='height: 100%;' src={parseImgUrlToken(selectItem.imgUrl)}></img>;
											} else {
												return <div></div>
											}
										},
										style: {
											borderBottom: 'none',
											borderTop: 'none',
											height: '60mm',
											flex: 'none',
											width: '100%',
											textAlign: 'center',
											paddingBottom:'5px'
										}
									},
								]
							}
						]
					},
					{
						style: {
							flexDirection: "column",
						},
						children:[
							{
								style: {
									flexDirection: "column",
								},
								children: [
									{
										text: '附加图',
										textStyle: this.zoomStyle,
										style: {
											borderBottom: 'none',
											height: '8mm',
											flex: 'none',
											width: '100%'
										}
									},
									{
										render(h, inner) {
											const selectItem = info.detailItemList.find(item => Number(item.usedPosition) === 4);
											if(selectItem) {
												return <img style='height: 100%;' src={parseImgUrlToken(selectItem.imgUrl)}></img>;
											} else {
												return <div></div>
											}
										},
										style: {
											borderBottom: 'none',
											borderTop: 'none',
											height: '60mm',
											flex: 'none',
											width: '100%',
											textAlign: 'center',
											paddingBottom:'5px'
										}
									},
								]
							}
						]
					},
				]
			},
			{
				children:[
				]
			}
		]
	}
}